<template>
  <div class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden" id="email-app">

    <!--SIDE BAR-->
    <vs-sidebar :click-not-close="clickNotClose"
                :hidden-background="clickNotClose"
                class="items-no-padding"
                parent="#email-app"
                v-model="isEmailSidebarActive">
      <private-message-side-bar :academicPeriod="academicPeriod"
                                :emailTags="emailTags"
                                :inboxUnreadQty="inboxUnreadQty"
                                :mailFilter="mailFilter"
                                :sentUnreadQty="sentUnreadQty"
                                @closeSidebar="toggleEmailSidebar"
                                @filterMails="filterMails"
                                @updateDateAfterSendMessage="updateDateAfterSendMessage"
                                v-if="academicPeriod"/>
    </vs-sidebar>

    <div :class="{'sidebar-spacer': clickNotClose}"
         class="no-scroll-content border border-solid d-theme-border-grey-light border-r-0 border-t-0 border-b-0">

      <!-- SEARCH BAR -->
      <div class="flex border d-theme-dark-bg items-center">
        <feather-icon @click.stop="toggleEmailSidebar(true)"
                      class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer"
                      icon="MenuIcon"/>
        <vs-input :placeholder="$t('pm.search-pm')"
                  class="vs-input-no-border vs-input-no-shdow-focus w-full" icon="icon-search" icon-no-border
                  icon-pack="feather"
                  size="large" v-model="messageSearchQuery"/>
      </div>

      <!-- EMAILS LIST -->
      <VuePerfectScrollbar :key="$vs.rtl" :settings="settings" class="email-content-scroll-area" ref="mailListPS">
        <transition-group appear class="email__mails" name="list-enter-up" tag="ul">
          <li :key="String(mailFilter) + String(mail.id)" :style="{transitionDelay: (index * 0.1) + 's'}"
              @click="updateOpenMail(mail)" class="cursor-pointer email__mail-item"
              v-for="(mail, index) in mails">
            <private-message-item :isSelected="isMailSelected(mail.id)" :mail="mail" :currentUser="currentUser"/>
          </li>
        </transition-group>
      </VuePerfectScrollbar>
    </div>

    <!-- EMAIL VIEW SIDEBAR -->
    <private-message-view
      :isSidebarActive="isSidebarActive"
      :openMailId="openMailId"
      :privateMessage="selectedPrivateMessage"
      :hasPreviousMail="hasPreviousMail"
      :hasNextMail="hasNextMail"
      :currentUser="currentUser"
      @closeSidebar="closeMailViewSidebar"
      @markUnread="updateSingleMarkUnread"
      @moveTo="moveCurrentTo"
      @nextMail="nextMail"
      @previousMail="previousMail"
      @removeMail="removeOpenMail"
      @updateOpenMail="updateOpenMail"
      @updateDateAfterReply="updateDateAfterReply">
    </private-message-view>

  </div>
</template>

<script>
  import PrivateMessageSideBar from "./Components/PrivateMessageSideBar";
  import PrivateMessageItem from "./Components/PrivateMessageItem";
  import PrivateMessageView from "./Components/PrivateMessageView";
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import store from '../../../store';
  import {createHelpers} from 'vuex-map-fields';
  import {createNamespacedHelpers} from "vuex";
  import PrivateMessage from '../../../store/modules/private-message/index';
  import User from '../../../store/modules/user';
  import ClassSection from '../../../store/modules/course/class-section';
  import AcademicPeriodConfig from '../../../store/modules/common-data/academic-period-config';
  import Notification from '../../../store/modules/notification/index';

  if (!store.state.PrivateMessage) store.state.registerModule(`PrivateMessage`, PrivateMessage);
  if (!store.state.User) store.state.registerModule(`User`, User);
  if (!store.state.ClassSection) store.state.registerModule(`ClassSection`, ClassSection);
  if (!store.state.AcademicPeriodConfig) store.state.registerModule(`AcademicPeriodConfig`, AcademicPeriodConfig);
  if (!store.state.Notification) store.state.registerModule(`Notification`, Notification);
  const {
    mapActions: mapPrivateMessageActions,
  } = createNamespacedHelpers(`PrivateMessage`);
  const {
    mapActions: mapClassSectionActions,
  } = createNamespacedHelpers(`ClassSection`);
  const {
    mapActions: mapAcademicPeriodConfigActions,
  } = createNamespacedHelpers(`AcademicPeriodConfig`);
  const {
    mapMutations: mapNotificationMutations
  } = createNamespacedHelpers(`Notification`);

  const {
    mapFields: mapPrivateMessageFields,
  } = createHelpers({
    getterType: `PrivateMessage/getField`,
    mutationType: `PrivateMessage/updateField`,
  });
  const {
    mapFields: mapUserFields,
  } = createHelpers({
    getterType: `User/getField`,
    mutationType: `User/updateField`,
  });
  const {
    mapFields: mapNotificationFields,
  } = createHelpers({
    getterType: `Notification/getField`,
    mutationType: `Notification/updateField`,
  });

  export default {
    components: {
      PrivateMessageSideBar,
      PrivateMessageItem,
      PrivateMessageView,
      VuePerfectScrollbar
    },
    data() {
      return {
        openMailId: null,
        selectedMails: [],
        isSidebarActive: false,
        showThread: false,
        clickNotClose: true,
        isEmailSidebarActive: true,
        settings: {
          maxScrollbarLength: 60,
          wheelSpeed: 0.30,
        },
        classSection: null,
        messageSearchQuery: '',
        privateMessageAll: [],
        privateMessagesReceive: [],
        privateMessagesSent: [],
        selectedPrivateMessage: {},
        loadingMessage: false,
        mailFilter: 'inbox',
        academicPeriod: null,
      }
    },
    watch: {
      isSidebarActive(value) {
        if (!value) this.showThread = false
      },
      mailFilter() {
        // this.selectedMails = []
        this.$refs.mailListPS.$el.scrollTop = 0
      },
      windowWidth() {
        this.setSidebarWidth();
      }
    },
    computed: {
      ...mapPrivateMessageFields({
        privateMessageProcessing: 'processing',
        privateMessageError: 'error',
        privateMessageSuccess: 'success'
      }),
      ...mapUserFields({
        currentUser: 'currentUser',
      }),
      ...mapNotificationFields({
        notifications: 'notifications',
      }),
      emailTags() {
        return []
      },
      selectAllCheckBox: {
        get() {
          return this.selectedMails.length
        },
        set(value) {
          value ? this.selectedMails = this.mails.map(mail => mail.id) : this.selectedMails = []
        }
      },
      mails() {
        let mails = [];
        if (this.mailFilter === 'inbox') {
          // mails = this.privateMessagesReceive;
          mails = mails.concat(this.privateMessagesReceive);
          mails = mails.concat(this.privateMessagesSent);
        }/* else if (this.mailFilter === 'sent') {
          mails = this.privateMessagesSent;
        }*/ else {
          // filter by class Section
          mails = mails.concat(this.privateMessagesReceive.filter(item => {
            return item.classSection.id === this.mailFilter
          }))
          mails = mails.concat(this.privateMessagesSent.filter(item => {
            return item.classSection.id === this.mailFilter
          }))
        }

        return this.searchQuery(mails)
      },
      selectAllIcon() {
        return this.selectedMails.length == this.mails.length ? 'icon-check' : 'icon-minus'
      },
      isMailSelected() {
        return (mailId) => this.selectedMails.indexOf(mailId) == -1 ? false : true
      },
      windowWidth() {
        return this.$store.state.windowWidth
      },
      inboxUnreadQty() {
        let unReadMessageQty = 0;
        if(this.currentUser){
          if (this.privateMessagesReceive && this.privateMessagesReceive.length > 0) {
            this.privateMessagesReceive.forEach(item => {
              // for receive message
              if(this.currentUser.id === item.toUser.id &&
                this.currentUser.id !== item.updatedBy.id){
                // if send to this user check hasNewReply
                if(item.hasNewReply || !item.readDate){
                  unReadMessageQty++;
                }
              }
            })
          }
          // for sent message
          // remove if show sent item on side bar
          if (this.privateMessagesSent && this.privateMessagesSent.length > 0) {
            this.privateMessagesSent.forEach(item => {
              const unRead = item.privateMessageReplies.filter(subItem => {
                return this.currentUser.id === subItem.toUser.id && !subItem.isRead
              })
              if(unRead && unRead.length > 0) {
                unReadMessageQty++;
              }
            })
          }
        }

        return unReadMessageQty;
      },
      sentUnreadQty() {
        let unReadMessageQty = 0;
        if (this.privateMessagesSent && this.privateMessagesSent.length > 0) {
          this.privateMessagesSent.forEach(item => {
            const unRead = item.privateMessageReplies.filter(subItem => {
              return this.currentUser.id === subItem.toUser.id && !subItem.isRead
            })
            if(unRead && unRead.length > 0) {
              unReadMessageQty++;
            }
          })
        }
        return unReadMessageQty;
      },
      hasNextMail() {
        const currentMailIndex = this.mails.findIndex((mail) => mail.id === this.openMailId)
        if (this.mails[currentMailIndex + 1]) {
          return true;
        }
        return false;
      },
      hasPreviousMail() {
        const currentMailIndex = this.mails.findIndex((mail) => mail.id === this.openMailId)
        if (this.mails[currentMailIndex - 1]) {
          return true;
        }
        return false;
      },
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//
      ...mapPrivateMessageActions({
        getPrivateMessagesByFilter: 'getPrivateMessagesByFilter',
        getPrivateMessagesSendToCurrentUser: 'getPrivateMessagesSendToCurrentUser',
        getPrivateMessagesSendFromCurrentUser: 'getPrivateMessagesSendFromCurrentUser',
        updatePrivateMessageAlreadyRead: 'updatePrivateMessageAlreadyRead',
      }),
      ...mapClassSectionActions({
        getClassSection: 'getClassSection',
      }),
      ...mapAcademicPeriodConfigActions({
        getCurrentAcademicPeriodConfig: 'getCurrentAcademicPeriodConfig',
      }),
      ...mapNotificationMutations({
        setNotifications: 'setNotifications',
      }),
      async updateOpenMail(privateMessage) {
        this.openMailId = privateMessage.id
        this.isSidebarActive = true
        this.selectedPrivateMessage = privateMessage;

        //if hasNewReply then update
        if(this.currentUser.id === privateMessage.toUser.id){
          if(privateMessage.hasNewReply || !privateMessage.readDate){
            await this.updateReadMessage(privateMessage);
          }
        }else{
          //check isRead in reply
          const unRead = privateMessage.privateMessageReplies.filter(subItem => {
            return this.currentUser.id === subItem.toUser.id && !subItem.isRead
          })
          if(unRead && unRead.length > 0) {
            await this.updateReadMessage(privateMessage);
          }
        }
      },
      addToSelectedMails(mailId) {
        if (this.selectedMails.indexOf(mailId) === -1) this.selectedMails.push(mailId)
      },
      removeSelectedMail(mailId) {
        const mailIndex = this.selectedMails.indexOf(mailId)
        if (mailIndex !== -1) this.selectedMails.splice(mailIndex, 1)
      },
      moveTo(to) {
        const payload = {emailIds: this.selectedMails, to: to}
        this.$store.dispatch('email/moveMailsTo', payload)
          .catch((error) => {
            console.error(error)
          })
        this.selectedMails = []
      },
      moveCurrentTo(to) {
        this.selectedMails = [this.openMailId]
        this.moveTo(to)
      },
      updateMarkUnread() {
        const payload = {emailIds: this.selectedMails, unreadFlag: true}
        this.$store.dispatch('email/setUnread', payload)
        this.selectedMails = []
      },
      removeOpenMail() {
        this.selectedMails = [this.openMailId]
        this.moveTo('trashed')
        this.isSidebarActive = false
      },
      toggleIsStarred() {
        const payload = {mailId: this.currentMail.id, value: !this.currentMail.isStarred}
        this.$store.dispatch('email/toggleIsMailStarred', payload)
      },
      nextMail() {
        const currentMailIndex = this.mails.findIndex((mail) => mail.id === this.openMailId)
        if (this.mails[currentMailIndex + 1]) {
          this.openMailId = this.mails[currentMailIndex + 1].id;
          this.selectedPrivateMessage = this.mails[currentMailIndex + 1];
        }
      },
      previousMail() {
        const currentMailIndex = this.mails.findIndex((mail) => mail.id === this.openMailId)
        if (this.mails[currentMailIndex - 1]) {
          this.openMailId = this.mails[currentMailIndex - 1].id
          this.selectedPrivateMessage = this.mails[currentMailIndex - 1];
        }
      },
      updateSingleMarkUnread() {
        this.selectedMails = [this.openMailId]
        this.updateMarkUnread()
        this.isSidebarActive = false
      },
      updateLabels(label) {
        this.$store.dispatch('email/updateLabels', {mails: this.selectedMails, label: label})
        this.selectedMails = []
      },
      closeMailViewSidebar() {
        this.isSidebarActive = false
      },
      setSidebarWidth() {
        if (this.windowWidth < 992) {
          this.isEmailSidebarActive = this.clickNotClose = false
        } else {
          this.isEmailSidebarActive = this.clickNotClose = true
        }
      },
      toggleEmailSidebar(value = false) {
        if (!value) {
          this.closeMailViewSidebar()
          if (this.clickNotClose) {
            return
          }
        }
        this.isEmailSidebarActive = value
      },
      filterMails(to) {
        this.messageSearchQuery = '';
        this.mailFilter = to;
        if(this.isSidebarActive) {
          this.closeMailViewSidebar();
        }
      },
      async updateReadMessage(privateMessage){
        const payload = {
          id: privateMessage.id
        }
        let result = await this.updatePrivateMessageAlreadyRead(payload);
        if(result){
          this.updateDataAfterSaveRead(result);

          //remove notification
          if(this.notifications && this.notifications.length > 0){
            const index = this.notifications.findIndex(item => item.type === 'privateMessage');
            const newNotifications = [
              ...this.notifications.slice(0, index),
              ...this.notifications.slice(index + 1)
            ];
            this.setNotifications(newNotifications);
          }
        }
      },
      updateDataAfterSaveRead(result){
        let index = this.privateMessagesReceive.findIndex(item => item.id === result.id);
        if(index > -1){
          this.privateMessagesReceive = [
            ...this.privateMessagesReceive.slice(0, index),
            result,
            ...this.privateMessagesReceive.slice(index + 1)
          ];
        }else{
          index = this.privateMessagesSent.findIndex(item => item.id === result.id);
          if(index > -1){
            this.privateMessagesSent = [
              ...this.privateMessagesSent.slice(0, index),
              result,
              ...this.privateMessagesSent.slice(index + 1)
            ];
          }
        }
      },
      updateDateAfterReply(result){
        let privateMessage = result.privateMessage;
        let index = this.privateMessagesReceive.findIndex(item => item.id === privateMessage.id);
        if(index > -1){
          this.privateMessagesReceive[index].privateMessageReplies.push(result);
        }else{
          index = this.privateMessagesSent.findIndex(item => item.id === privateMessage.id);
          if(index > -1){
            this.privateMessagesSent[index].privateMessageReplies.push(result);
          }
        }
      },
      updateDateAfterSendMessage(result){
        if(this.isSidebarActive){
          this.closeMailViewSidebar();
        }
        this.privateMessagesSent.unshift(result);
      },
      searchQuery(mails) {
        if (mails && mails.length > 0) {
          return mails.filter((pm) => {
            return pm.topic.toLowerCase().includes(this.messageSearchQuery.toLowerCase()) ||
              pm.fromUser.code.toLowerCase().includes(this.messageSearchQuery.toLowerCase()) ||
              pm.fromUser.nameLocal.toLowerCase().includes(this.messageSearchQuery.toLowerCase()) ||
              pm.fromUser.surnameLocal.toLowerCase().includes(this.messageSearchQuery.toLowerCase()) ||
              pm.courseOutlineRegistration.subjectCode.toLowerCase().includes(this.messageSearchQuery.toLowerCase())
          }).sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
        }
        return [];
      },
      async loadData() {
        this.loadingMessage = true;
        const payload = {
          academicPeriodId:  this.academicPeriod.id,
        }

        await this.filterReceiveMessageData(payload);
        await this.filterSendMessageData(payload);
        this.loadingMessage = false;
      },
      async filterReceiveMessageData(payload) {
        let result = await this.getPrivateMessagesSendToCurrentUser(payload);
        if (result) {
          result = JSON.parse(JSON.stringify(result));
          this.privateMessagesReceive = result;
        }
      },
      async filterSendMessageData(payload) {
        let result = await this.getPrivateMessagesSendFromCurrentUser(payload);
        if (result) {
          result = JSON.parse(JSON.stringify(result));
          this.privateMessagesSent = result;
        }
      },
      async initData() {
        const result = await this.getCurrentAcademicPeriodConfig();
        if(result){
          this.academicPeriod = result.learnPeriod;
        }
      },
    },
    created() {
      this.setSidebarWidth()
    },
    async beforeMount() {
      await this.initData();
      await this.loadData();
    },
  }

</script>

<style lang="scss">
  @import "@/assets/scss/vuexy/apps/email.scss";
</style>
